import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class DeleteAnnouncementsErrorAction implements Action {
  public static readonly type = 'DeleteAnnouncementsErrorAction';

  constructor(public error: BijbError) {
  }

  public type = DeleteAnnouncementsErrorAction.type;
}
